<template>
    <span :class="{filled: filled}" class="symbol"></span>
</template>

<script setup lang="ts">
    defineProps<{
        filled: boolean;
    }>();
</script>

<style lang="scss" scoped>
    .symbol {
        display: block;
        width: 29px;
        height: 4px;
        border-radius: var(--joy-core-radius-4);
        background-color: var(--joy-color-neutral-30);
    }

    .filled {
        background-color: var(--joy-color-secondary-50);
    }
</style>
